// @ts-nocheck
import React from 'react'
import moment from 'moment-timezone'
import { CloseIcon } from 'transfix-icons'
import { FORMATS } from 'constants/datetime'

interface IEditedPackageFilesRowProps {
  document: {
    createdAt: string
    fileName: string
    fileUrl: string
    file: string
    id: string
  }
  deleteDocUpload: (...args: any[]) => any
}

export const EditedPackageFilesRow: React.FunctionComponent<IEditedPackageFilesRowProps> = React.memo(
  ({ deleteDocUpload, document }) => {
    const onDelete = () => {
      deleteDocUpload(document.id)
    }
    return (
      <div>
        {document.fileName && (
          <span key={document.fileName}>
            <a
              href={document.fileUrl}
              target='_blank'
              rel='noopener noreferrer'
              data-test='uploaded-docs'>
              {document.fileName}
            </a>
            <div>
              <CloseIcon
                className='fr'
                size='xlarge'
                onClick={onDelete}
                data-test='single-doc-delete'
                accent
              />
            </div>
            <p className='text-secondary'>
              {moment(document.createdAt).format(FORMATS.dateFormat)}
            </p>
            <hr />
          </span>
        )}
      </div>
    )
  }
)
